<template>
  <div id="freetour-video-box">
    <vue-plyr ref="freetour">
      <video :autoplay="false" controls playsinline>
        <source size="480" :src="videoSrc.av" type="video/mp4" />
        <source size="720" :src="videoSrc.hd" type="video/mp4" />
        <source size="1080" :src="videoSrc.fullhd" type="video/mp4" />
        <source size="2160" :src="videoSrc.ultrahd" type="video/mp4" />                        
      </video>
    </vue-plyr>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import VuePlyr from 'vue-plyr'
  import { mapState } from 'pinia'
  import { localeStore } from '../../stores/locale'

  import 'vue-plyr/dist/vue-plyr.css'

  export default defineComponent({
    name: 'BoxVideo',
    components: { VuePlyr },
    computed: {
        ...mapState(localeStore, ['locale']),
    },
    data() {
      return {
        videoSrc: this.getVideo(),
        bannerVideo: '',
        quality: { options: [], forced: true, default: '1080' },
      }
    },
    watch: {
        'locale': function () {
          this.getBannerVideo()
        }
    },
    mounted(){
      this.getBannerVideo()
    },
    methods: {
      getBannerVideo() {
        if (this.locale == 'en') {
          this.$refs.freetour.player.poster =  'https://api.belladasemana.com.br/storage/freetour/en/freetou-img-video-2.jpg'
        } else {
          this.$refs.freetour.player.poster =  'https://api.belladasemana.com.br/storage/freetour/br/freetou-img-video-2.jpg'
        }
      },
      getVideo() {
        return {
          bv: 'https://api.belladasemana.com.br/storage/freetour/videos/bv.mp4',
          av: 'https://api.belladasemana.com.br/storage/freetour/videos/av.mp4',
          hd: 'https://api.belladasemana.com.br/storage/freetour/videos/hd.mp4',
          fullhd: 'https://api.belladasemana.com.br/storage/freetour/videos/fullhd.mp4',
          ultrahd: 'https://api.belladasemana.com.br/storage/freetour/videos/4k.mp4'
        }
      }
    }
  })
</script>
